import { ChangeEvent, FC, FormEvent, useRef, useState } from 'react'
import classNames from 'classnames'
import update from 'immutability-helper'
import sharedClasses from '@modals/index.module.css'
import Button from '@UI/New/Button'
import { InputWhite } from '@UI/New/InputWhite'
import { usersAPI } from '@/api'
import type { StudentContractState } from './AddContractModal'
import classes from './index.module.css'

type AddContractFormProps = {
  state: StudentContractState
  setState: (value: StudentContractState) => void
  close?: () => void
  onSuccess?: () => void
}

const AddContractForm: FC<AddContractFormProps> = ({
  state,
  setState,
  close,
  onSuccess,
}) => {
  const fileInputRef = useRef<HTMLInputElement | null>(null)
  const [name, setName] = useState('')
  const [file, setFile] = useState<File | null>(null)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const isSubmitDisabled = !name.trim() || !file || isSubmitting

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event.target.files?.[0]
    if (!selectedFile) return

    setFile(selectedFile)
    event.currentTarget.value = ''
  }

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    if (!name.trim() || !file || !state?.id) {
      return
    }

    const formData = new FormData()
    formData.append('file', file)
    formData.append('name', name.trim())
    formData.append('user_id', String(state.id))

    setIsSubmitting(true)

    usersAPI
      .addContract({ data: formData })
      .then((res: any) => {
        if (res.data.status === 'success') {
          return usersAPI
            .getUser({ id: state.id, expand: ['contracts'] })
            .then((userRes: any) => {
              setState(
                update(state, {
                  contracts: { $set: userRes.data.contracts },
                }),
              )
              onSuccess?.()
              close?.()
            })
        }
      })
      .finally(() => {
        setIsSubmitting(false)
      })
  }

  return (
    <form
      onSubmit={handleSubmit}
      className={classNames(sharedClasses.contentWrapper, classes.form)}
    >
      <InputWhite
        title="Название договора"
        value={name}
        onChange={setName}
        placeholder="Введите название файла"
        className={classes.input}
      />

      <div className={classes.field}>
        <span className={classes.fieldTitle}>Файл договора</span>
        <input
          ref={fileInputRef}
          type="file"
          className={classes.hiddenInput}
          onChange={handleFileChange}
        />
        <Button
          type="button"
          color="gray"
          disabled={isSubmitting}
          onClick={() => fileInputRef.current?.click()}
        >
          {file ? 'Выбрать другой файл' : 'Загрузить файл'}
        </Button>
        {file ? (
          <ul className={classes.filesList}>
            <li className={classes.fileItem}>{file.name}</li>
          </ul>
        ) : null}
      </div>

      <div className={classes.footer}>
        <Button
          type="submit"
          color="primary"
          disabled={isSubmitDisabled}
          isLoading={isSubmitting}
          className={classes.submitButton}
        >
          Сохранить
        </Button>
      </div>
    </form>
  )
}

export default AddContractForm
